import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Logo, Wordmark } from "@/components/Brand";

const TITLES = {
  about: "About BrewMate",
  help: "Help & Support",
  contact: "Contact Us",
  terms: "Terms & Conditions",
  privacy: "Privacy Policy",
};

export default function InfoPage({ type }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    if (type === "terms" || type === "privacy") {
      api.get(`/legal/${type}`).then(({ data }) => setData(data)).catch(() => {});
    } else {
      api.get(`/content/${type}`).then(({ data }) => setData(data.value)).catch(() => {});
    }
  }, [type]);

  return (
    <div data-testid={`info-page-${type}`}>
      <PageHeader title={TITLES[type]} />
      <div className="px-5 pt-5 pb-10">
        {type === "about" && (
          <div className="flex flex-col items-center text-center mb-6">
            <Logo size={72} />
            <h2 className="mt-4 text-3xl"><Wordmark className="text-[#EDE0CC]" /></h2>
            <p className="mt-1 text-sm text-[#EDE0CC]/70">Powered by Wonderbean Coffee Co.</p>
            <p className="mt-1 text-base text-[#EDE0CC]/90">Better coffee, made simple.</p>
          </div>
        )}

        {type === "contact" && data ? (
          <div className="space-y-3 text-sm text-[#EDE0CC]/90">
            <Row label="Support email" value={data.support_email} />
            <Row label="Privacy email" value={data.privacy_email} />
            <Row label="Website" value={data.website} />
            <Row label="Support hours" value={data.hours} />
            <Row label="Registered address" value={data.address} />
          </div>
        ) : (
          <p className="text-base leading-relaxed text-[#EDE0CC]/90 whitespace-pre-line">
            {data ? (data.body ?? "") : "Loading…"}
          </p>
        )}

        {(type === "terms" || type === "privacy") && data && (
          <p className="mt-6 text-xs text-[#EDE0CC]/50">Version {data.version} — Effective {data.effective_date}</p>
        )}
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="rounded-2xl border border-[#EDE0CC]/15 bg-[#0D2875] p-4">
      <div className="text-xs uppercase tracking-wide text-[#EDE0CC]/50">{label}</div>
      <div className="mt-1 break-words">{value}</div>
    </div>
  );
}
